import React from "react";
import { Button } from "@material-tailwind/react";
import { Backdrop, Box, Fade, Modal } from "@mui/material";
import { IoClose } from "react-icons/io5";

function AddController(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    padding: "45px",
    outline: "none",
    borderRadius: "35px",
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.open}
        // onClose={props.onClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <div className="flex justify-between items-center">
              <p className="font-bold text-[40px] text-black">
                {props.modal?.update_controller
                  ? "Update"
                  : props.modal?.add_controller
                  ? "Add"
                  : ""}{" "}
                Controller
              </p>
              {!props.loading?.btn && (
                <IoClose
                  className="cursor-pointer border border-[#BDBDBD] rounded-full absolute right-6 top-8 text-[#BDBDBD]"
                  onClick={props.onClose}
                />
              )}
            </div>
            <form
              onSubmit={
                props.modal?.update_controller
                  ? props.handleUpdateSubmit
                  : props.handleAddSubmit
              }
              className="mt-3 w-[300px] sm:w-[400px] flex flex-col gap-3"
            >
              <input
                className="w-full bg-[#F5F7F9] px-7 py-6 outline-none border-none rounded-2xl text-[#8f8f8f] custom-number-input"
                type="number"
                placeholder="Hardware ID *"
                value={props.addFieldData?.hardware_id}
                onChange={(e) =>
                  props.setAddFieldData({
                    ...props.addFieldData,
                    hardware_id: e.target.value?.slice(0, 16),
                  })
                }
                onKeyDown={(e) => {
                  if (
                    e.key === "e" ||
                    e.key === "E" ||
                    e.key === "-" ||
                    e.key === "+"
                  ) {
                    e.preventDefault();
                  }
                }}
                onWheel={(e) => e.target.blur()}
                required
              />
              <Button
                type="submit"
                disabled={props.loading?.btn}
                className="mt-2 rounded-2xl bg-[#03438D] px-7 py-6 tracking-widest font-poppins font-light text-lg"
              >
                {props.loading?.btn ? "Loading..." : "Continue"}
              </Button>
            </form>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default AddController;
